import {useEffect, useState} from 'react'
import {useSelector} from '../../store.js'
import {supplierFiltersSelector} from './analyticsSelectors.js'
import SupplierFilter from '../../common/components/SupplierFilter.js'
import handleListSelection from '../../common/handleListSelection.js'
import {setSupplierFilters} from './analyticsActions.js'
import {FILTER_SELECT_ALL} from '../../common/components/FilterDropdown.js'

export async function handleAnalyticsSupplierListSelection({
  option,
  event,
  list,
  selectedIDs,
  setSelectedIDs,
  lastSelectedID,
  setLastSelectedID,
}) {
  list = list
    .filter(({type}) => type !== FILTER_SELECT_ALL)
    .map(({entity: {id}}) => id)

  if (option.type === FILTER_SELECT_ALL) {
    setSelectedIDs(selectedIDs.length === list.length ? [] : list)

    return
  }

  const supplierID = option.entity.id

  setSelectedIDs(
    handleListSelection({
      value: supplierID,
      isSelected: event
        ? event.target.checked
        : !selectedIDs.includes(supplierID),
      isShiftKey: event?.shiftKey,
      selected: selectedIDs,
      list,
      previousValue: lastSelectedID,
    }),
  )

  setLastSelectedID(supplierID)
}

export default function AnalyticsSupplierFilter() {
  const supplierFilters = useSelector(supplierFiltersSelector)
  const [selectedIDs, setSelectedIDs] = useState([])
  const [lastSelectedID, setLastSelectedID] = useState(null)

  useEffect(() => {
    setSelectedIDs(supplierFilters)
  }, [supplierFilters])

  return (
    <SupplierFilter
      label="Filter by Supplier"
      dropdown="analytics_supplier_filter"
      value={selectedIDs}
      onSelect={(option, event, list) =>
        handleAnalyticsSupplierListSelection({
          option,
          event,
          list,
          selectedIDs,
          setSelectedIDs,
          lastSelectedID,
          setLastSelectedID,
        })
      }
      onChange={() => setSupplierFilters(selectedIDs)}
      includeSelectAll
    />
  )
}
